<template>
    <div>
        <div>
            <template v-for="option in options" :key="option.value">
                <div class="form-group">
                    <label class="form-label label-auto" :for="'opt-' + option.value">
                        <input
                            :id="'opt-' + option.value"
                            v-model="choice"
                            type="radio"
                            name="options"
                            :value="option.value"
                        />
                        {{ option.label }}
                    </label>
                </div>
            </template>
        </div>
    </div>
</template>
<script>
import ListingFilterMixin from './ListingFilterMixin.js';

export default {
    mixins: [ListingFilterMixin],
    data() {
        return {
            choice: '',
        };
    },
    computed: {
        data() {
            return {
                choice: this.choice,
            };
        },

        options() {
            const options = this.filter.inputs.choice.options;

            return Object.values(options).sort((a, b) => {
                if (a.rank != undefined) {
                    return a.rank > b.rank ? 1 : -1;
                } else {
                    return a.label > b.label ? 1 : -1;
                }
            });
        },
    },
};
</script>
